'use client';

import * as React from 'react';
import type { ConsentCategories } from '@/lib/consent/gtag';

export type CookieConsentContext = {
  consentCategories: ConsentCategories | null;
  updateConsentCategories: (categories: ConsentCategories) => void;
};

export const CookieConsentContext =
  React.createContext<CookieConsentContext | null>(null);
